// TODO: remove .filter-item references
import Scroll from './Scroll';
import IsMobile from './IsMobile';
const FILTER_MOBILE_BREAKPOINT = 1173;
const SLIDE_DURATION_MS = 400;
export default (() => {
    console.log('UNTUCKit : Module : Filter : loaded');
    let isMobile = false;
    let collectionRoots = [];
    const isHidden = (element) => getComputedStyle(element).display === 'none';
    const runAnimation = (element, keyframes, complete) => {
        if (typeof element.animate !== 'function') {
            complete();
            return;
        }
        const animation = element.animate(keyframes, {
            duration: SLIDE_DURATION_MS,
            easing: 'ease',
            fill: 'forwards',
        });
        animation.onfinish = () => {
            animation.cancel();
            complete();
        };
    };
    const slideUp = (element) => {
        const computed = getComputedStyle(element);
        runAnimation(element, [
            {
                height: computed.height,
                paddingTop: computed.paddingTop,
                paddingBottom: computed.paddingBottom,
                marginTop: computed.marginTop,
                marginBottom: computed.marginBottom,
            },
            {
                height: '0px',
                paddingTop: '0px',
                paddingBottom: '0px',
                marginTop: '0px',
                marginBottom: '0px',
            },
        ], () => {
            element.style.display = 'none';
            element.style.height = '';
            element.style.padding = '';
            element.style.margin = '';
        });
    };
    const slideDown = (element) => {
        element.style.display = 'block';
        const computed = getComputedStyle(element);
        runAnimation(element, [
            {
                height: '0px',
                paddingTop: '0px',
                paddingBottom: '0px',
                marginTop: '0px',
                marginBottom: '0px',
            },
            {
                height: `${element.scrollHeight}px`,
                paddingTop: computed.paddingTop,
                paddingBottom: computed.paddingBottom,
                marginTop: computed.marginTop,
                marginBottom: computed.marginBottom,
            },
        ], () => {
            element.style.height = '';
            element.style.padding = '';
            element.style.margin = '';
        });
    };
    const slideToggle = (element) => {
        if (isHidden(element)) {
            slideDown(element);
        }
        else {
            slideUp(element);
        }
    };
    const closestIn = (origin, selector, root) => {
        const match = origin.closest(selector);
        if (!match || !root.contains(match)) {
            return null;
        }
        return match;
    };
    const removeAncestorClass = (start, selector, className) => {
        let parent = start.parentElement;
        while (parent) {
            if (parent.matches(selector)) {
                parent.classList.remove(className);
            }
            parent = parent.parentElement;
        }
    };
    const closeSiblingWraps = (wrap) => {
        const parent = wrap.parentElement;
        if (!parent) {
            return;
        }
        Array.from(parent.children).forEach((sibling) => {
            if (sibling !== wrap && sibling.classList.contains('toggle-wrap')) {
                sibling.classList.remove('is-active');
            }
        });
    };
    const setURLParams = (key, value) => {
        if (typeof key === 'undefined') {
            history.pushState({ title: document.title }, document.title, window.location.href.split('?')[0]);
            return;
        }
        const urlConnect = window.location.search === '' ? '?' : '&';
        history.pushState({ title: document.title }, document.title, `${window.location.href}${urlConnect}${key}=${value}`);
    };
    const onResize = () => {
        if (isMobile && !IsMobile.check(FILTER_MOBILE_BREAKPOINT)) {
            Scroll.unlock();
            isMobile = false;
        }
        else if (!isMobile && IsMobile.check(FILTER_MOBILE_BREAKPOINT)) {
            isMobile = true;
        }
    };
    const onBodyClick = () => {
        if (isMobile) {
            return;
        }
        document.querySelectorAll('.toggle-wrap').forEach((wrap) => {
            wrap.classList.remove('is-active');
        });
    };
    const onToggleTrigger = (event, trigger) => {
        console.log('.js-toggle-trigger clicked');
        const wrap = trigger.parentElement;
        if (!(wrap instanceof HTMLElement)) {
            return;
        }
        event.stopPropagation();
        event.preventDefault();
        if (wrap.classList.contains('is-active')) {
            wrap.classList.remove('is-active');
            trigger.setAttribute('aria-expanded', 'false');
            return;
        }
        trigger.setAttribute('aria-expanded', 'true');
        wrap.classList.add('is-active');
        closeSiblingWraps(wrap);
    };
    const onToggleSort = (sortButton) => {
        removeAncestorClass(sortButton, '.toggle-wrap', 'is-active');
        Scroll.unlock();
    };
    const onSortItem = (sortItem) => {
        const previous = sortItem.parentElement?.previousElementSibling;
        if (!(previous instanceof HTMLElement)) {
            return;
        }
        previous.click();
        const label = previous.querySelector('span');
        if (label) {
            label.textContent = sortItem.textContent;
        }
    };
    const onHeading = (event, heading) => {
        if (!IsMobile.check(FILTER_MOBILE_BREAKPOINT)) {
            return;
        }
        heading.classList.toggle('is-active');
        const panel = heading.nextElementSibling;
        if (panel instanceof HTMLElement) {
            slideToggle(panel);
        }
        event.stopPropagation();
    };
    const onApply = (applyButton) => {
        setURLParams();
        removeAncestorClass(applyButton, '.toggle-wrap', 'is-active');
        Scroll.unlock();
    };
    const onClear = (clearButton) => {
        let parent = clearButton.parentElement;
        while (parent) {
            if (parent.matches('.toggle-target')) {
                parent.parentElement?.classList.remove('is-active');
            }
            parent = parent.parentElement;
        }
        document.querySelectorAll('.js-remove-filter').forEach((chip) => {
            chip.remove();
        });
        Scroll.unlock();
    };
    const onCollectionClick = (event) => {
        const root = event.currentTarget;
        if (!(root instanceof Element) || !(event.target instanceof Element)) {
            return;
        }
        const origin = event.target;
        if (closestIn(origin, '.filter.toggle-target', root)) {
            event.stopPropagation();
        }
        const trigger = closestIn(origin, '.js-toggle-trigger', root);
        if (trigger instanceof HTMLElement) {
            onToggleTrigger(event, trigger);
        }
        const sortButton = closestIn(origin, '.js-toggle-sort', root);
        if (sortButton) {
            onToggleSort(sortButton);
        }
        const sortItem = closestIn(origin, '.sort-item', root);
        if (sortItem instanceof HTMLElement) {
            onSortItem(sortItem);
        }
        const heading = closestIn(origin, '.js-heading', root);
        if (heading instanceof HTMLElement) {
            onHeading(event, heading);
        }
        const applyButton = closestIn(origin, '.js-apply', root);
        if (applyButton) {
            onApply(applyButton);
        }
        const clearButton = closestIn(origin, '.js-clear', root);
        if (clearButton) {
            onClear(clearButton);
        }
    };
    const unbindUIActions = () => {
        window.removeEventListener('resize', onResize);
        document.body.removeEventListener('click', onBodyClick);
        collectionRoots.forEach((root) => {
            root.removeEventListener('click', onCollectionClick);
        });
        collectionRoots = [];
    };
    const bindUIActions = () => {
        window.addEventListener('resize', onResize);
        document.body.addEventListener('click', onBodyClick);
        collectionRoots = Array.from(document.querySelectorAll('.templateCollection'));
        collectionRoots.forEach((root) => {
            root.addEventListener('click', onCollectionClick);
        });
    };
    function init() {
        console.log('UNTUCKit : Module : Filter : init');
        isMobile = IsMobile.check(FILTER_MOBILE_BREAKPOINT);
        unbindUIActions();
        if (!document.querySelector('.mix-container')) {
            return;
        }
        bindUIActions();
        document.querySelectorAll('.filter-bar').forEach((bar) => {
            bar.classList.remove('is-disabled');
        });
    }
    return {
        init,
    };
})();
